module.exports = __webpack_public_path__ + "img/148-madeira.38718f96.svg";